import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/auth-context';

// Marketing Pages (PUBLIC)
import HomePage from './pages/marketing/HomePage';
import ScholingenPage from './pages/marketing/ScholingenPage';
import LessonDetailPage from './pages/marketing/LessonDetailPage';
import NieuwsbriefPage from './pages/marketing/NieuwsbriefPage';
import PostDetailPage from './pages/marketing/PostDetailPage';
import OverOnsPage from './pages/marketing/OverOnsPage';
import ContactPage from './pages/marketing/ContactPage';
import PrivacyPage from './pages/marketing/PrivacyPage';
import AlgemeneVoorwaardenPage from './pages/marketing/AlgemeneVoorwaardenPage';

// Auth Pages (PUBLIC)
import LoginPage from './pages/auth/LoginPage';
import RegisterPage from './pages/auth/RegisterPage';
import RegisterSuccessPage from './pages/auth/RegistersuccessPage';
import VerifyEmailPage from './pages/auth/VerifyEmailPage';
import ForgotPasswordPage from './pages/auth/ForgotPasswordPage';
import ResetPasswordPage from './pages/auth/ResetPasswordPage';

// Dashboard / Lesson Pages
import UserDashboard from './pages/dashboard/UserDashboard';
import Les1Dashboard from './pages/Les1Dashboard';
import LessonLayout from './pages/LessonLayout';

// Payment Pages
import PaymentPage from './pages/payment/PaymentPage';
import PaymentReturnPage from './pages/payment/PaymentReturnPage';

// Protected Route Component
const ProtectedRoute = ({ children }) => {
  const auth = useAuth();
  const isAuthenticated = auth?.isAuthenticated ?? false;
  const isLoading = auth?.isLoading ?? true;

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-cream-100">
        <p className="text-charcoal-800">Bezig met laden...</p>
      </div>
    );
  }

  return isAuthenticated ? children : <Navigate to="/login" replace />;
};

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          {/* ===== PUBLIC MARKETING ROUTES ===== */}
          <Route path="/" element={<HomePage />} />
          <Route path="/scholingen" element={<ScholingenPage />} />
          <Route path="/haalmeeruitverandertaal" element={<LessonDetailPage />} />
          <Route path="/nieuwsbrief" element={<NieuwsbriefPage />} />
          <Route path="/nieuwsbrief/:slug" element={<PostDetailPage />} />
          <Route path="/over-ons" element={<OverOnsPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/algemene-voorwaarden" element={<AlgemeneVoorwaardenPage />} />

          {/* ===== PUBLIC AUTH ROUTES ===== */}
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/register-success" element={<RegisterSuccessPage />} />
          <Route path="/verify-email/:token" element={<VerifyEmailPage />} />
          <Route path="/forgot-password" element={<ForgotPasswordPage />} />
          <Route path="/reset-password/:token" element={<ResetPasswordPage />} />

          {/* ===== PROTECTED DASHBOARD ROUTES ===== */}
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <UserDashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/les1"
            element={
              <ProtectedRoute>
                <Les1Dashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/les1/:moduleId"
            element={
              <ProtectedRoute>
                <LessonLayout />
              </ProtectedRoute>
            }
          />

          {/* ===== PROTECTED PAYMENT ROUTES (placeholders) ===== */}
          <Route
            path="/payment/:lessonId"
            element={
              <ProtectedRoute>
                <PaymentPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/payment/return"
            element={
              <ProtectedRoute>
                <PaymentReturnPage />
              </ProtectedRoute>
            }
          />

          {/* ===== FALLBACK ===== */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;